'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createChainablePropType = require('./createChainablePropType');

var _createChainablePropType2 = _interopRequireDefault(_createChainablePropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var domElementPropType = function domElementPropType(props, propName, componentName) {
  var value = props[propName];
  if (value == null || (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value.nodeType === 1) return null;
  return new Error(componentName + ': Invalid ' + propName + ' value. Expected a DOM element.');
};

exports.default = (0, _createChainablePropType2.default)(domElementPropType, 'DOM element');
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/utils/propTypes/domElement.js
// module id = 95
// module chunks = 3 4 5